export const Services = {
   "Tickets": {
      "path": "https://servicedeskapitickets.azurewebsites.net/",
      "method": "",
      "descrp": "Get - Post Tickets"
   },
   "Comments": {
      "path": "https://servicedeskapitickets.azurewebsites.net/",
      "method": "",
      "descrp": "Get - Post Comments"
   },
   "DocumentsTick": {
      "path": "https://servicedeskapitickets.azurewebsites.net/",
      "method": "",
      "descrp": "Get - Post Documents"
   },
   "CatalogosTick": {
      "path": "https://servicedeskapitickets.azurewebsites.net/",
      "method": "",
      "descrp": "Get - Catalogos"
   },
   "Project": {
      "path": "https://servicedeskapitickets.azurewebsites.net/",
      "method": "",
      "descrp": "Get - Project"
   },
   "generate_xls": {
      "path": "https://servicereportapi.azurewebsites.net/report/dynamic/xlsx",
      "method": "",
      "descrp": "Dowload xls"
   }
}